const replaceIcons = (): void => {
  const buildSpanFromPlain = (plain: string): HTMLSpanElement => {
    const span = document.createElement('span');
    const regex = /\|([^|]+)\|/g;
    let lastIndex = 0;
    let m: RegExpExecArray | null;

    while ((m = regex.exec(plain)) !== null) {
      if (m.index > lastIndex) {
        span.append(document.createTextNode(plain.slice(lastIndex, m.index)));
      }
      const i = document.createElement('i');
      i.className = m[1].trim();
      span.append(i);
      lastIndex = regex.lastIndex;
    }
    if (lastIndex < plain.length) {
      span.append(document.createTextNode(plain.slice(lastIndex)));
    }
    return span;
  };

  const candidates: Element[] = [];
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_ELEMENT,
    {
      acceptNode: (node: Node) => {
        const el = node as Element;
        const tag = el.tagName.toLowerCase();

        // never traverse into these
        if (tag === 'script' || tag === 'style' || tag === 'i') {
          return NodeFilter.FILTER_REJECT;
        }

        // only process <button> or <a> elements themselves
        if (tag !== 'button' && tag !== 'a') {
          return NodeFilter.FILTER_SKIP;
        }

        return el.textContent && /\|[^|]+\|/.test(el.textContent)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      },
    } as unknown as NodeFilter
  );

  let current: Node | null = walker.nextNode();
  while (current) {
    candidates.push(current as Element);
    current = walker.nextNode();
  }

  // depth helper (kept in case you want to keep deepest-first order)
  const depth = (el: Element): number => {
    let d = 0,
      p: Element | null = el;
    while ((p = p?.parentElement ?? null)) d++;
    return d;
  };

  candidates
    .sort((a, b) => depth(b) - depth(a))
    .forEach((el) => {
      const plain = (el.textContent || '').trim();
      if (!/\|[^|]+\|/.test(plain)) return;
      const span = buildSpanFromPlain(plain);
      // replace the contents of the <button>/<a> only
      el.replaceChildren(span);
    });
};

export default replaceIcons;
